import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=23f1850e&scoped=true"
import script from "./steps.vue?vue&type=script&setup=true&lang=ts"
export * from "./steps.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1850e",
  null
  
)

export default component.exports